import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Team from './icon-team.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Team {...validProps} />;
}
SvgComponent.iconName = 'iconTeam';

/**
 * @deprecated This is a legacy icon
 */
export const TeamIcon = svgIconWrapper(SvgComponent);
